import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useEmergencyContacts from '../useEmergencyContacts';
import DeleteModal from 'components/deleteModalView';
import SendMessageModal from './sendMessageModal';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';
import { map } from 'lodash';

const MainPage = () => {
  const {
    data,
    columns,
    rowSelection,
    filters,
    loading,
    onChangeTableFilter,
    handleDownloadExcel,
    onDelete,
    updateInProcess,
    selectedRowIds,
    handleSendMessage,
  } = useEmergencyContacts();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);
  data.company_emergency_contacts.map((element) => {
    // Convert the number to a string
    let phoneString = element.phone.toString();

    // Replace the last 5 digits with asterisks
    phoneString = phoneString.slice(0, -5) + '*****';

    // Convert the string back to a number
    element.phone = phoneString;
  });
  return (
    <>
      <PageHeader title={t('CONTATTI DI EMERGENZA').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              loading={loading}
              onClick={handleDownloadExcel}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <Link to={'send/message'}>
          <Button big disabled={!selectedRowIds.length}>
            {t('Invia messaggio')}
          </Button>
        </Link>
        <Divider />
        <Table
          rowKey={'id'}
          loading={loading}
          onChange={onChangeTableFilter}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data.company_emergency_contacts}
          pagination={data.pagination}
          scroll={{ x: 2000 }}
        />
      </div>
      <Routes>
        <Route
          exact
          path={'send/message'}
          element={
            <SendMessageModal
              onClickSend={handleSendMessage}
              loading={updateInProcess}
            />
          }
        />
        <Route
          path={':id/delete'}
          element={
            <DeleteModal onClickDelete={onDelete} loading={updateInProcess} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
